import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export const ItemResource = () => {
  return Vue.resource('items{/id}', {})
}



// WEBPACK FOOTER //
// ./src/api/item.js